import { DateTime } from 'luxon';

import { DateZone, MarketHours } from '@oai-frontend-monorepo/types';

export const shortDays = {
  '2024-11-29': true,
  '2024-12-24': true,
  '2025-07-03': true,
};

export const mapHolidays = (marketInfo?: MarketHours) => {
  const thisYear = DateTime.utc().setZone(DateZone.New_York).year;

  const holidays = marketInfo?.stockMarketHolidays.find(
    (arr) => arr.year === thisYear
  );

  if (!holidays) {
    return {};
  }

  const holidayMap: { [key: string]: string } = Object.keys(holidays)
    .filter((k) => k !== 'year')
    .reduce((acc: { [key: string]: string }, key) => {
      const holiday = holidays[key as keyof typeof holidays];
      if (holiday !== undefined) {
        acc[holiday] = key;
      }
      return acc;
    }, {});

  return holidayMap;
};
